import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Settings, Activity, Monitor, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useTranslation } from 'react-i18next';

const ProductCategories = () => {
  const { t } = useTranslation();

  const categories = [
    {
      id: 'tractor',
      title: t('products.categories.tractor.title'),
      description: t('products.categories.tractor.description'),
      icon: Settings,
      link: '/products/tractor',
      color: 'bg-blue-50 text-blue-600',
    },
    {
      id: 'logging_tools',
      title: t('products.categories.logging_tools.title'),
      description: t('products.categories.logging_tools.description'),
      icon: Activity,
      link: '/products/logging_tools',
      color: 'bg-green-50 text-green-600',
    },
    {
      id: 'downhole_accessories',
      title: t('products.categories.downhole_accessories.title'),
      description: t('products.categories.downhole_accessories.description'),
      icon: Wrench,
      link: '/products/downhole_accessories',
      color: 'bg-orange-50 text-orange-600',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-[#0A1F44] text-white py-20">
        <div className="max-w-6xl mx-auto px-6 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t('products.header.title')}
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed mx-auto md:mx-0">
            {t('products.header.description')}
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <Link key={category.id} to={category.link} className="group block h-full">
              <Card className="h-full border-none shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden bg-white group-hover:-translate-y-1">
                <CardContent className="p-8 flex flex-col h-full">
                  <div className={`w-14 h-14 rounded-2xl ${category.color} flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110`}>
                    <category.icon className="h-7 w-7" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-[#0A1F44] mb-3 group-hover:text-[#FF6A00] transition-colors">
                    {category.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-8 flex-grow leading-relaxed">
                    {category.description}
                  </p>

                  <div className="flex items-center text-[#FF6A00] font-semibold group/btn">
                    {t('common.explore')} 
                    <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <section className="bg-white py-20 border-t border-gray-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-[#0A1F44] mb-4">
            {t('products.cta.title')}
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            {t('products.cta.description')}
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-[#FF6A00] hover:bg-[#E55F00] text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
              {t('products.cta.button')}
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProductCategories;
